import {Form} from "antd";
import {SAlert, SDrawerOrModal, SGeneralForms} from "shj-components";
import React from "react";

const DefineNameModal = (props) => {
  const {open, onClose, onReload} = props;
  const [form] = Form.useForm()

  const onFinish = (values) => {
    console.log(values);
    onClose()
  }

  return <>
    <SDrawerOrModal
      title={'所属产品库'}
      mode="modal"
      width={620}
      open={open}
      loading={false}
      onCancel={onClose}
      onOk={onFinish}
    >
      <SAlert type="info">
        <p>“自定义” 指名称只能在产品库编辑中修改，来源物料、施工的修改后不会自动同步。</p>
        <p>“来源定义” 指来源物料、施工的SPU，优先取来源的名称（来源修改后会自动同步）</p>
      </SAlert>
      <SGeneralForms
        formConfig={{form}}
        configs={[{
          formItem: [
            {
              spanCol: 24,
              label: '名称定义',
              required: true,
              rules: [{ required: true, message: '名称定义不能为空' }],
              name: 'type',
              type: 'radio',
              comConfig: {
                options: [
                  { label: '自定义', value: '1' },
                  { label: '来源定义', value: '2' },
                ]
              },
            },
          ]
        }]}
      />
    </SDrawerOrModal>
  </>
}

export default DefineNameModal